
import React from "react";
import {Button, Col, Container, Row, Accordion, Card} from "react-bootstrap";
import {buildUrl} from "../service/url-builder";
import Select from "react-select";
import {Link} from "react-router-dom";


const DAYS_OF_WEEK = ["Sun","Mon","Tues","Wed","Thurs","Fri","Sat"];

function weekOfYear(theDate){
    let onejan = new Date(theDate.getFullYear(), 0, 1);
    return Math.ceil( (((theDate.getTime() - onejan.getTime()) / 86400000) + onejan.getDay() + 1) / 7 );
}

function displayCurrency(number){
    return number.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
    });
}

function SummaryList(props) {
    const summaryData = props.summaryData;
    let totalDays = 0;
    let totalPNL = 0;
    let weekPNL = 0;
    let monthPNL = 0;
    const listItems =[];

    let week = 0;
    let month = 0;
    for(let index = 0; index< summaryData.length; index++){
        let summary = summaryData[index];
        let theDay = new Date(summary.date);
        let generatedOn = new Date(summary.generatedDate);

        let link = `/harness/chart`;


        if(summary.date != "none") {
            let currentItemWeek = weekOfYear(theDay);
            let currentItemMonth = theDay.getMonth();

            if(week !== currentItemWeek){
                listItems.push(<Row key={index +'_week_summary'}>
                    <Col>Weekly Total PNL:{displayCurrency(weekPNL)}</Col>
                </Row>);
                week = currentItemWeek;
                weekPNL =0;
            }

            if(month !== currentItemMonth){
                listItems.push(<Row key={index +'_month_summary'}>
                    <Col>Monthly Total PNL:{displayCurrency(monthPNL)}</Col>
                </Row>);
                month = currentItemMonth;
                monthPNL = 0;
            }

            totalDays++;
            totalPNL += summary.totalPnL;
            weekPNL += summary.totalPnL;
            monthPNL += summary.totalPnL;

            let dateArg = theDay.toISOString().slice(0, 10).replaceAll('-', '');
            link = `/harness/chart?date=${dateArg}&config=${summary.config.name}`;

        }

        listItems.push(<Row key={index}>
            <Col>{DAYS_OF_WEEK[theDay.getDay()]}</Col>
            <Col>{theDay.toLocaleDateString("en-US")}</Col>
            <Col>{summary.totalPnL}</Col>
            <Col>{summary.totalOrders}</Col>
            <Col>{summary.executedTrades}</Col>
            <Col>{summary.buyOrdersFilled}/{summary.sellOrdersFilled}/{summary.cancelledTrades}</Col>
            <Col>{summary.dailyTicks}</Col>
            <Col>{summary.errorCount}</Col>
            <Col>{generatedOn.toLocaleString("en-US")}</Col>
            <Col><Link to={`${link}`}>view</Link></Col>
        </Row>);

        if(index === summaryData.length -1){
            listItems.push(<Row key={index +'_total_summary'}>
                <Col>Total PNL:{displayCurrency(totalPNL)}</Col>
            </Row>);
        }
    }

    return (
        <div className="press-grid">
            <Container style={{'margin':'10px 0'}} >
                <Row>
                    <Col>Day</Col>
                    <Col>Date</Col>
                    <Col>PnL</Col>
                    <Col>Placed</Col>
                    <Col>Executed</Col>
                    <Col>Buy/Sell/Can</Col>
                    <Col>Ticks</Col>
                    <Col>Errors</Col>
                    <Col>Generated On:</Col>
                    <Col>View</Col>
                </Row>
                {listItems}
            </Container>
        </div>
    );
}
export {SummaryList}
